import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { BlockBaseProps, BlockBorderProps, BlockWrapper } from "@tKgpco/Components/Common/Block/Block";
import { defaultBorderProps } from "@tKgpco/Components/Common/Block/defaultProps";
import { BlockVariantBaseProps, BlockVariantSide } from "@tKgpco/Components/Common/Block/variant/base";
import { getVariantBorderProps } from "@tKgpco/Components/Common/Block/variant/utilities";
import breakpointValuesMediaQueries from "@tKgpco/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

export interface BlockVariantSeparatedBaseProps {
    border: BlockBorderProps;
    adaptToContext?: boolean;
}
export interface BlockVariantSeparatedProps extends BlockVariantBaseProps, BlockVariantSeparatedBaseProps {}

const defaultProps: BlockVariantSeparatedProps = {
    border: defaultBorderProps,
};

const staticProps: BlockVariantBaseProps = {
    containerCss: css<BlockBaseProps>`
        ${({ variantProps }) =>
            variantProps?.separated?.adaptToContext
                ? css`
                      &:first-child ${BlockWrapper} {
                          padding-top: 0;
                          border-top: 0;
                      }

                      &:last-child ${BlockWrapper} {
                          padding-bottom: 0;
                          border-bottom: 0;
                      }
                  `
                : null}
    `,
    wrapperCss: css<BlockBaseProps>`
        ${({ theme, variantProps, variantSide, margin = [] }) => {
            const { width, type, color } = getVariantBorderProps(variantProps?.separated);

            const _topStyles = css`
                border-top: ${width} ${type} ${resolveColor(color, theme)};
            `;
            const _bottomStyles = css`
                border-bottom: ${width} ${type} ${resolveColor(color, theme)};
            `;

            switch (variantSide) {
                case BlockVariantSide.Top:
                    return css`
                        ${_topStyles}
                        ${breakpointValuesMediaQueries(
                            theme,
                            [{ values: margin, properties: ["padding-top"] }],
                            mediaOptions.min,
                        )}
                    `;
                case BlockVariantSide.Bottom:
                    return css`
                        ${_bottomStyles}
                        ${breakpointValuesMediaQueries(
                            theme,
                            [{ values: margin, properties: ["padding-bottom"] }],
                            mediaOptions.min,
                        )}
                    `;
                default:
                    return css`
                        ${_topStyles} ${_bottomStyles}
                        ${breakpointValuesMediaQueries(
                            theme,
                            [{ values: margin, properties: ["padding-top", "padding-bottom"] }],
                            mediaOptions.min,
                        )}
                    `;
            }
        }}
    `,
};

export default { defaultProps, staticProps };
